import { IServerUser, IUser } from "../interfaces";

export const getUserDisplayName = (user: IUser | undefined) => {
    return user ? `${user.firstName || ''} ${user.lastName || ''}` : '';
};

export const getServerUserDisplayName = (
    user: IServerUser | null | undefined
) => {
    return user ? `${user.first_name || ''} ${user.last_name || ''}`.trim() : '';
};
